import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DevisStatut, IDevisResponse } from 'src/app/shared/models/devis';
import { DevisService } from '../../devis.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'app-devis-refuse-dialog',
  templateUrl: './devis-refuse-dialog.component.html',
  styleUrls: ['./devis-refuse-dialog.component.less']
})
export class DevisRefuseDialogComponent {

  form: FormGroup;
  saving = false;

  constructor(
    private fb: FormBuilder,
    private devisService: DevisService,
    private snackbarService: SnackbarService,
    private authService: AuthenticationService,
    public dialogRef: MatDialogRef<DevisRefuseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDevisResponse
  ) {
    this.form = this.fb.group({
      devisMotifRefus: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  onRefuser(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const { devisMotifRefus } = this.form.value;
    const userRole = this.authService.getUser()?.profile as string ?? undefined;

    this.devisService.updateStatut(this.data.devisId, DevisStatut.REFUSE, devisMotifRefus, undefined, undefined, undefined, userRole).subscribe({
      next: () => {
        this.snackbarService.openSnackBar('Devis refusé');
        this.dialogRef.close(true);
      },
      error: () => {
        this.snackbarService.openSnackBar('Erreur lors du refus', 'error-snack-bar');
        this.saving = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
